module.exports = __webpack_public_path__ + "static/media/semfulllogo.2407876d.svg";